export default __webpack_public_path__ + "static/media/logo.f357a4bb.webp";